export default __webpack_public_path__ + "static/media/set14.fa3c8232.jpeg";